// extracted by mini-css-extract-plugin
module.exports = {"container":"eRZc8","forumContainer":"_1-SkV","divider":"_31Ppc"};